import { useState } from "react";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, formatApiError } from "@/lib/api";

const EMPTY = { property_id: "", nome: "", cognome: "", data_nascita: "", codice_fiscale: "", canone: "", giorno_scadenza: "5" };

const Field = ({ label, children }) => <div><label className="field-label">{label}</label>{children}</div>;

export const AddTenantDialog = ({ properties, onCreated }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.property_id) return toast.error("Seleziona un immobile");
    try {
      await api.post("/tenants", {
        ...form, canone: Number(form.canone), giorno_scadenza: Number(form.giorno_scadenza),
        data_nascita: form.data_nascita || null, codice_fiscale: form.codice_fiscale || null,
      });
      toast.success("Inquilino aggiunto");
      setForm(EMPTY);
      setOpen(false);
      onCreated();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="button-add-tenant" className="btn-primary" disabled={properties.length === 0} title={properties.length === 0 ? "Aggiungi prima un immobile" : ""}>
          <UserPlus className="h-4 w-4" />Nuovo inquilino
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Nuovo inquilino</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <Field label="Immobile">
              <Select value={form.property_id} onValueChange={(v) => setForm({ ...form, property_id: v })}>
                <SelectTrigger data-testid="select-tenant-property"><SelectValue placeholder="Seleziona immobile" /></SelectTrigger>
                <SelectContent>{properties.map((p) => <SelectItem key={p.id} value={p.id} data-testid={`select-property-option-${p.id}`}>{p.nome} — {p.citta}</SelectItem>)}</SelectContent>
              </Select>
            </Field>
          </div>
          <Field label="Nome"><input data-testid="input-tenant-nome" required className="field-input" value={form.nome} onChange={set("nome")} /></Field>
          <Field label="Cognome"><input data-testid="input-tenant-cognome" required className="field-input" value={form.cognome} onChange={set("cognome")} /></Field>
          <Field label="Data di nascita"><input data-testid="input-tenant-data-nascita" type="date" className="field-input" value={form.data_nascita} onChange={set("data_nascita")} /></Field>
          <Field label="Codice fiscale"><input data-testid="input-tenant-cf" maxLength={16} className="field-input uppercase" value={form.codice_fiscale} onChange={set("codice_fiscale")} /></Field>
          <Field label="Canone mensile (€)"><input data-testid="input-tenant-canone" required type="number" min="1" step="0.01" className="field-input" value={form.canone} onChange={set("canone")} /></Field>
          <Field label="Giorno di scadenza"><input data-testid="input-tenant-scadenza" required type="number" min="1" max="28" className="field-input" value={form.giorno_scadenza} onChange={set("giorno_scadenza")} /></Field>
          <button data-testid="button-save-tenant" type="submit" className="btn-accent sm:col-span-2">Salva inquilino</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
